import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./css/infistaking.css";
import { href } from "react-router";

export default function InfiStaking() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const infiApplicationForm = () => {
    navigate(`${config.baseUrl}infiListingForm`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="infiStaking position-relative pt-5 pb-0 mt-0">
        <div class="bg-shape">
          <img alt="" src="images/shape/bg-shape.png" />
        </div>
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center">
            <Col lg={12}>
              <div className="">
                <Card className="overflow-hidden bg-transparent border-0">
                  <Card.Body>
                    <div className="text-center position-relative mb-5">
                      <h1 className="text-white lh-sm mb-3">
                        Unlock the Power of Participation with INFI
                      </h1>
                      <p className="text-light-grey2">
                        Stake your INFI tokens to unlock exclusive benefits in the SbSe Protocol - powered decentralized ecosystem — 
                      including voting rights, community-led improvements, and access to dynamic rewards
                      </p>
                    </div>
                    <div>
                      <Row>
                        <Col lg={4} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox2">
                              <div>
                                <img
                                  src="images/icon/liquidity.png"
                                  class="infi-icon "
                                  alt=""
                                />
                                <h5 className="mb-3 text-white fw-normal">
                                  INFI Staking (Decentralized &
                                  Utility-Focused)
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        Community Rewards Access
                                      </span>{" "}
                                      – Stake INFI to unlock
                                      eligibility for protocol-based
                                      incentives distributed via smart
                                      contracts.
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        Transparent & SelfCustodial
                                      </span>{" "}
                                      – Real-time tracking
                                      on-chain with full control over
                                      your assets at all times.
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        Fixed Participation Period
                                      </span>{" "}
                                      – Commit to a 24-month staking
                                      cycle to support network
                                      governance and protocol
                                      functions.
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={4} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox2">
                              <div>
                                <img
                                  src="images/icon/sbsetrading.png"
                                  class="infi-icon "
                                  alt=""
                                />
                                <h5 className="mb-3 text-white fw-normal">
                                  Protocol Pools
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        Access Protocol Rewards
                                      </span>{" "}
                                      – Participate in on-chain activity to
                                      become eligible for dynamic
                                      incentives.
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        Manual Claim System
                                      </span>{" "}
                                      – Users can claim distributions
                                      based on protocol usage and
                                      staking parameters.
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        Multi-Asset Distribution
                                      </span>{" "}
                                      – Incentives may be made
                                      available in DAI or supported
                                      tokens depending on ecosystem
                                      activity.
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={4} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox2">
                              <div>
                                <img
                                  src="images/icon/passiveincome.png"
                                  class="infi-icon "
                                  alt=""
                                />
                                <h5 className="mb-3 text-white fw-normal">
                                  SbSe Pools
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        SbSe PFP Pools
                                      </span>{" "}
                                      – Protocolmanaged incentive pools that
                                      may be made available to
                                      eligible INFI participants based
                                      on on-chain activity.
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        SbSe Reserve
                                      </span>{" "}
                                      – Decentralized contingency fund
                                      designed to support the 48-hour
                                      protocol-based incident response
                                      mechanism.
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅{" "}
                                      <span className="text-white fw-bold">
                                        SbSe Treasury
                                      </span>{" "}
                                      – Smart
                                      contract–governed resource pool
                                      supporting infrastructure
                                      development, liquidity, and
                                      ongoing ecosystem operations.
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="text-center">
                            <Button
                              variant="white-gradient"
                              className="me-3 px-5 rounded-5"
                              onClick={() => window.open("https://infimultichain.com/exch/", "_blank")}
                            >
                              Know More&nbsp;&nbsp;
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 19"
                                fill="none"
                              >
                                <path
                                  d="M15.7921 1.08813L22.6729 9.21992M22.6729 9.21992L15.7921 17.3517M22.6729 9.21992L1.3269 9.21992"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </Button>
                            <Button
                              variant="default"
                              className="border px-5 rounded-5 text-white fw-normal"
                              href={`${config.baseUrl}whitepaper`} target="_blank" rel="noopener noreferrer"
                            >
                              INFI WhitePaper&nbsp;&nbsp;
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 19"
                                fill="none"
                              >
                                <path
                                  d="M15.7308 1.21997L22.5 9.21997M22.5 9.21997L15.7308 17.22M22.5 9.21997L1.5 9.21997"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
